import * as logging from "../utils/log";

"use strict";

export function get(reqUrl : string, data : {[key : string] : any} = {})
{
	return call(reqUrl, 'GET', data);
}

export function post(reqUrl : string, data : {[key : string] : any} = {})
{
	return call(reqUrl, 'POST', data);
}

export function call(reqUrl : string, method : string, data : {[key : string] : any})
{
	return new Promise((resolve, reject) => {
		$.ajax({
			method: method,
			url: reqUrl,
			dataType: 'json',
			data: data,
			success:function(response) { resolve(response); },
			error:function(...args : any[]) { logging.error("Failed to call WebAPI2", ...args); reject(); }
		});
	});
}

const ajaxAPI = {get, post};
export default ajaxAPI;
